import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const ChartIcon = forwardRef<SVGSVGElement, IconProps>(function ChartIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.2246 8.85786C1.0663 8.14555 1 7.21833 1 6C1 4.78167 1.0663 3.85445 1.2246 3.14214C1.38208 2.43353 1.61743 2.00048 1.90261 1.7153C2.45865 1.15926 3.51052 0.86722 6 0.86722C8.48948 0.86722 9.54135 1.15926 10.0974 1.7153C10.3826 2.00048 10.6179 2.43353 10.7754 3.14214C10.9337 3.85445 11 4.78167 11 6C11 7.21833 10.9337 8.14555 10.7754 8.85786C10.6179 9.56647 10.3826 9.99952 10.0974 10.2847C9.54135 10.8407 8.48948 11.1328 6 11.1328C3.51052 11.1328 2.45865 10.8407 1.90261 10.2847C1.61743 9.99952 1.38208 9.56647 1.2246 8.85786ZM6 12C1.059 12 0 10.941 0 6C0 1.059 1.059 0 6 0C10.941 0 12 1.059 12 6C12 10.941 10.941 12 6 12Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3.06639C6.27614 3.06639 6.5 3.26052 6.5 3.5V8.5C6.5 8.73948 6.27614 8.93361 6 8.93361C5.72386 8.93361 5.5 8.73948 5.5 8.5V3.5C5.5 3.26052 5.72386 3.06639 6 3.06639ZM8.5 5.06639C8.77614 5.06639 9 5.26052 9 5.5V8.5C9 8.73948 8.77614 8.93361 8.5 8.93361C8.22386 8.93361 8 8.73948 8 8.5V5.5C8 5.26052 8.22386 5.06639 8.5 5.06639ZM3.5 6.06639C3.77614 6.06639 4 6.26052 4 6.5V8.5C4 8.73948 3.77614 8.93361 3.5 8.93361C3.22386 8.93361 3 8.73948 3 8.5V6.5C3 6.26052 3.22386 6.06639 3.5 6.06639Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
